<div id="head"></div>
<h1 class="sr-only">Contrast Checker - Check WCAG Color Contrast For Text And Backgrounds</h1>

<!-- ===================== Hero: the checker itself ===================== -->
<div class="default-section initial-section metallic-section no-buttons wp-hero" data-section="top">
  <div class="cp-hero-head">
    <p class="tools-title" aria-hidden="true">Contrast Checker</p>
    <p class="tools-subtitle">{{ fg }} on {{ bg }} is {{ ratioLabel }}:1</p>
  </div>

  <app-contrast-widget [fg]="fg" [bg]="bg" (colorsChange)="onColors( $event )"></app-contrast-widget>
</div>

<nav class="cp-chipbar" appStuck aria-label="Contrast checker sections">
  <div class="cp-chipbar-row">
    <a *ngFor="let s of pageSections" class="pl-chip" [class.on]="activeSection === s.key" [attr.href]="'#sec-' + s.key"
       (click)="$event.preventDefault(); scrollToSection( s.key )">
      <span>{{ s.label }}</span>
    </a>
  </div>
</nav>

<div class="cp-body cp-boxes">
  <div class="cp-content">

    <!-- Fixes: the nearest passing colours, one click to take them over -->
    <section class="cp-section" id="sec-fixes" data-section="fixes">
      <header class="cp-head">
        <h2 class="cp-h2">Fixes</h2>
        <p class="cp-section-lead">The closest colors that pass, the same hue with only the lightness moved</p>
      </header>
      <div class="cp-main">
        <div class="cc-fix-grid">
          <div class="cc-fix" *ngFor="let f of fixes" [class.cc-fix-none]="!f.reachable">
            <div class="cc-fix-sample" [style.background-color]="f.bg" [style.color]="f.fg">
              <span class="cc-fix-aa">Aa</span>
              <span class="cc-fix-ratio">{{ f.ratio }}:1</span>
            </div>
            <div class="cc-fix-body">
              <span class="cc-fix-title">{{ f.title }}</span>
              <span class="cc-fix-note">{{ f.note }}</span>
              <span class="cc-fix-hexes" *ngIf="f.reachable">{{ f.fg }} on {{ f.bg }}</span>
            </div>
            <button type="button" class="cp-std-btn cc-fix-use" *ngIf="f.reachable" [disabled]="f.fg === fg && f.bg === bg"
                    (click)="use( f.fg, f.bg, 'fix' )">Use</button>
          </div>
        </div>
      </div>
    </section>

    <!-- Color Vision: the pair as each colour vision deficiency sees it, with its ratio -->
    <section class="cp-section" id="sec-vision" data-section="vision">
      <header class="cp-head">
        <h2 class="cp-h2">Color Vision Deficiency</h2>
        <p class="cp-section-lead">How your two colors read to people with color vision deficiencies, and the contrast they keep</p>
      </header>
      <div class="cp-main">
        <div class="cc-vision-grid">
          <div class="cc-vision" *ngFor="let v of vision">
            <div class="cc-vision-sample" [style.background-color]="v.bg" [style.color]="v.fg">
              <span class="cc-vision-text">Readable text</span>
              <span class="cc-vision-ratio" [class.fail]="!v.pass">{{ v.ratio }}:1</span>
            </div>
            <p class="cp-cv-cap"><span class="cp-cv-name">{{ v.name }}:</span> <span class="cp-cv-desc">{{ v.note }}</span></p>
          </div>
        </div>
      </div>
    </section>

    <!-- More Color Tools (owner 2026-10-22): the Color Picker, above How It Works (no Related Themes or blog here) -->
    <app-more-tools sectionKey="more" title="More Color Tools" lead="Pick any color on your screen and read it the same way, right from your menu bar"
                    [app]="colorPicker" [source]="moreToolsSource"></app-more-tools>

    <app-tool-about [lead]="aboutLead" [paragraphs]="aboutParagraphs" [faq]="faq" ratingKey="contrast-checker" ratingName="the Contrast Checker"></app-tool-about>
  </div>
</div>
